import React, { useState, useEffect, useRef } from "react"
import showToast from "../../components/Common/viewNotification"
import DataTable from "react-data-table-component"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import SessionConfig from "../../config/session_config"
import { is_empty } from "../../config/validate"
import LinearIndeterminate from "../../components/Common/LinearIndeterminate"
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  Button,
  FormFeedback,
  CardTitle,
  InputGroup,
  Label,
} from "reactstrap"
import "./supplier.scss"
import { Link } from "react-router-dom"
import Select from "react-select"
import {
  getSuppliers,
  deleteSupplier,
  getSociety,
  editSupplierClean,
  getTypesArea,
  exportSupplier,
  dataExportSupplierClean
} from "../../store/actions"
import SupplierLimitForm from "./supplierLimitForm"
import dictionary from "../../config/dictionary"
// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"
const supplier = () => {
  const { t } = useTranslation()
  document.title = t("supplier:title") + " | " + t("global:title")
  const {
    suppliers,
    societies,
    loadingSociety,
    loading,
    error,
    response,
    areaList,
    dataExport,
    band
  } = useSelector(state => ({
    suppliers: state.Suppliers.suppliers,
    societies: state.Society.societies,
    loadingSociety: state.Society.loading,
    loading: state.Suppliers.loading,
    error: state.Suppliers.error,
    response: state.Suppliers.response,
    areaList: state.fileRequirement.areaList,
    dataExport: state.Suppliers.dataExport,
    band: state.Suppliers.dataPending
  }))
  const ref = useRef()
  const [data, setData] = useState({
    columns: [],
    selectedRows: [],
  })
  const [page, setPage] = useState(0)
  const [size, setSize] = useState(10)
  const [errorSelect] = useState({ exist: false, msg: "" })
  const [modal, setModal] = useState(false)
  const [clearSelectedRows, setclearSelectedRows] = useState(false)
  const dispatch = useDispatch()
  const [toggleSwitch, settoggleSwitch] = useState(true)
  const [society, setsociety] = useState("")
  const [currentSupplier, setCurrentSupplier] = useState(null)
  const [codeSapFilter, setCodeOrName] = useState("")
  const [area, setArea] = useState({ value: "", label: "", error: "" })
  const [percentageModalOpen, setPercentageModalOpen] = useState(false);
  const [nameSupplier, setNameSupplier] = useState(null);
  const [documentTotal, setDocumentTotal] = useState({
    totalRequired: 0,
    totalUploaded: 0,
    percentage: 0,
  });
  const [documentMaterial, setDocumentMaterial] = useState({
    totalRequired: 0,
    totalUploaded: 0,
    percentage: 0,
  });
  const togglePercentageModal = () => setPercentageModalOpen(!percentageModalOpen)
  const toggle = () => {
    if (modal) {
      setModal(false)
    } else {
      setModal(true)
    }
  }
  useEffect(() => {
    if (society) {
      initTable()
      loadSuppliers()
    }
  }, [society, page, size])

  useEffect(() => {
    initData()

  }, [])
  useEffect(() => {
    if (societies?.length > 0) {
      if (society.id !== societies[0]?.id) setsociety(societies[0])
    }
  }, [societies])

  useEffect(() => {
    if (!is_empty(error)) {
      showToast(error, "error", t("error:title"))
    }
  }, [error])
  useEffect(() => {
    if (!is_empty(response)) {
      showToast(t("supplier:stateChange"), "success", t("supplier:title"))
      loadSuppliers()
      dispatch(editSupplierClean())
    }
  }, [response])

  useEffect(() => {
    initDataExport()
  }, [dataExport])

  const initData = async () => {
    document.getElementById("body").className = "fondo2"
    await dispatch(getSociety())
    await dispatch(getTypesArea(dictionary.configApp.concept.areaCode))
    await dispatch(dataExportSupplierClean())
  }

  const initDataExport = async () => {

    if (dataExport?.length) {
      buildXls()
    } else {
      if (band) {
        showToast(error, "warning", t("exportSupplier:messageEmpty"))
      }
    }
  }

  const buildXls = async () => {
    const rows = []
    const wscols = [{ wch: 10 }, { wch: 30 }, { wch: 30 }, { wch: 30 }]
    const columnName = [
      t("exportSupplier:titleCode"),
      t("exportSupplier:titleName"),
      t("exportSupplier:titleArea"),
      t("exportSupplier:titleMaterial"),
    ]
    dataExport?.map(row => {
      rows.push({
        titleCode: row.supplier.code,
        titleName: row.supplier.name,
        titleArea: row.supplier.area.code + " - " + row.supplier.area.name,
        titleMaterial: row.codeSap + " - " + row.name,
      })
    })

    const XLSX = require("xlsx")
    var ws = XLSX.utils.json_to_sheet(rows)
    var wb = XLSX.utils.book_new()
    XLSX.utils.sheet_add_aoa(ws, [columnName], { origin: "A1" })
    ws["!cols"] = wscols
    if (rows.length > 0) {
      XLSX.utils.book_append_sheet(wb, ws, "Datos")
      await XLSX.writeFile(
        wb,
        t("exportSupplier:titleSupplier") +
        dataExport[0].supplier.code +
        "." +
        "xls"
      )
      await dispatch(dataExportSupplierClean())
    } else {
      showToast(error, "warning", t("exportSupplier:messageEmpty"))
    }
  }

  const loadSuppliers = () => {
    const filter = {
      length: size,
      page: page,
      codeOrName: validationFilter.values.codeOrName,
      areaId: area.value,
      username: sessionStorage.getItem("username"),
    }
    dispatch(getSuppliers({ filter }))
  }

  const initTable = () => {
    data.columns = [
      {
        name: t("supplier:titleName"),
        sortable: false,
        wrap: true,
        grow: 4,
        cell: row => (
          <div>
            <div className=" text-uppercase">{row.name}</div>
            <span
              to="#"
              className={
                row.status === 1
                  ? "badge badge-soft-primary font-size-11 m-1"
                  : "badge badge-soft-danger font-size-11 m-1"
              }
            >
              {row.status === 1 ? "HABILITADO" : "DESHABILITADO"}
            </span>
          </div>
        ),
      },
      {
        name: "Area",
        sortable: false,
        wrap: true,
        grow: 2,
        cell: row => <div className=" text-uppercase">{row.areaName}</div>,
      },
      {
        name: t("supplier:titleNit"),
        sortable: false,
        wrap: true,
        grow: 1,
        cell: row => <div className=" text-muted">{row.nit}</div>,
      },
      {
        name: t("supplier:titleCode"),
        sortable: false,
        wrap: true,
        grow: 1,
        right: true,
        cell: row => <div className="  ">{row.code}</div>,
      },
      {
        name: t("supplier:lblModalLimit"),
        sortable: false,
        wrap: true,
        grow: 1,
        cell: row => (
          <h5 className=" badge badge-soft-dark ">{row.userLimit}</h5>
        ),
      },
      {
        name: t("supplier:lblPercentage"),
        sortable: false,
        wrap: true,
        grow: 1,
        right: true,
        cell: row => (
          <h5 className={row.percentage == 0 ? "text-danger" : ""}
           onClick={() => handleViewPercentage(row)}>
            {row.percentage?.toFixed(2)} %
          </h5>
        ),
      },

      {
        name: "Accion",
        cell: row => (
          <div className="d-flex gap-3">
            <Link className="text-warning" to="#">
              <i
                className="fas fa-newspaper font-size-18"
                title="Ver porcentaje"
                onClick={() => handleViewPercentage(row)}
              ></i>
            </Link>
            <Link className="text-primary" to="#">
              <i
                className="fa fa-edit font-size-18"
                id="edittooltip"
                onClick={() => handleEditLimitClick(row)}
              ></i>
            </Link>
            <Link className="text-success" to="#">
              <i
                className="fas fa-file-excel font-size-18"
                id="exceltooltip"
                onClick={() => onClickDownloadSupplier(row)}
              ></i>
            </Link>
          </div>
        ),
      },
    ]
  }
  const handleEditLimitClick = row => {
    setCurrentSupplier(row)
    toggle()
  }

  const onClickDownloadSupplier = async row => {
    await dispatch(exportSupplier(row.supplierId))
    await dispatch(dataExportSupplierClean())
  }

  const updateState = (value, id) => {
    setData({
      ...data,
      [id]: value,
    })
  }

  const handleSelectRow = React.useCallback(state => {
    updateState(state.selectedRows, "selectedRows");
  }, []);

  const handlePerRowsChange = async (perPage, page) => {
    let pageRows = parseInt(page) - 1
    if (pageRows < 0) {
      pageRows = 0
    }
    await setPage(pageRows)
    await setSize(perPage)
  }

  const handlePageChange = async page => {
    let pageRows = parseInt(page) - 1
    if (pageRows < 0) {
      pageRows = 0
    }
    await setPage(pageRows)
  }
  const submitChangeStatus = async e => {
    e.preventDefault()
    if (data.selectedRows.length > 0) {
      let lsDelete = []

      data.selectedRows.map(element => {
        lsDelete.push({ id: element.supplierId })
      })

      setclearSelectedRows(true)
      await dispatch(deleteSupplier(lsDelete, !toggleSwitch ? 0 : 1))
      setclearSelectedRows(false)
    }
  }

  const validationFilter = useFormik({
    enableReinitialize: true,
    initialValues: {
      codeOrName: "",
      socie: "",
    },
    validationSchema: Yup.object({}),
    onSubmit: values => {
      setCodeOrName(values.codeOrName)
      const filter = {
        length: 10,
        page: 0,
        code: values.codeOrName,
        society: society ? society : "BO80",
        username: sessionStorage.getItem("username"),
      }
      dispatch(getSuppliers({ filter }))
    },
  })

  const areaLs = () => {
    if (areaList.length > 0) {
      return areaList?.map(item => {
        return { value: item.id, label: item.name }
      })
    } else {
      return []
    }
  }
  const changeArea = value => {
    if (value === null) {
      setArea({ value: "", label: "" })
    } else {
      setArea({ value: value.value, label: value.label })
    }
  }

  const contextActions = React.useMemo(() => {
    return (
      <React.Fragment>
        <Form onSubmit={submitChangeStatus}>
          <Row>
            <Col className="form-check form-switch">
              <input
                type="checkbox"
                className="form-check-input "
                id="customSwitch2"
                defaultChecked={toggleSwitch}
                onClick={e => {
                  settoggleSwitch(e?.target?.checked)
                }}
              />
            </Col>

            <Col>
              <Button
                key="delete"
                color={toggleSwitch ? t("primary") : t("danger")}
                type="submit"
                disabled={loading}
              >
                {toggleSwitch ? t("supplier:enabled") : t("supplier:disabled")}
              </Button>
            </Col>
          </Row>
        </Form>
      </React.Fragment>
    )
  })

  const handleViewPercentage = row => {
    setNameSupplier(row.name);

    setDocumentTotal({
      totalRequired: row.totalRequired,
      totalUploaded: row.totalUploaded,
      percentage: row.percentage?.toFixed(2),
    });

    setDocumentMaterial({
      totalRequired: row.totalRequiredMaterial,
      totalUploaded: row.totalUploadedMaterial,
      percentage: row.percentageMaterial?.toFixed(2),
    });

    setPercentageModalOpen(true);
  };

  return (
    <React.Fragment>
      <SessionConfig ref={ref} />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={t("global:title")}
            breadcrumbItem={t("supplier:title")}
          />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <CardTitle className="h5 mb-4 text-primary">
                    {t("monitor:filter")}
                  </CardTitle>
                  <Row mb="5">
                    <Col lg={12}>
                      <Row>
                        <Col lg={4}>
                          <div>
                            <Label htmlFor="name">
                              {t("supplier:lblArea")}
                            </Label>
                            <Select
                              name="area"
                              isClearable
                              options={areaLs()}
                              value={area}
                              onChange={value => changeArea(value)}
                            />
                            <span className="small text-danger">
                              {area.error}
                            </span>
                          </div>
                        </Col>

                        <Col lg={3}>
                          <Label htmlFor="name">
                            {t("supplier:codeOrName")}
                          </Label>
                          <InputGroup>
                            <Input
                              name="codeOrName"
                              placeholder={t("supplier:codeOrName")}
                              type="text"
                              onChange={validationFilter.handleChange}
                              onBlur={validationFilter.handleBlur}
                              value={validationFilter.values.codeOrName || ""}
                            />
                            {validationFilter.touched.codeOrName &&
                              validationFilter.errors.codeOrName ? (
                              <FormFeedback type="invalid">
                                {validationFilter.errors.codeOrName}
                              </FormFeedback>
                            ) : null}
                            <button
                              type="button"
                              className="btn btn-primary save-user"
                              disabled={loading}
                              onClick={loadSuppliers}
                            >
                              <i className=" fas fa-search me-1 " />
                            </button>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <DataTable
                    title={
                      <label className="text-primary text-uppercase font-size-16">
                        <i className="fa fa-list font-size-18  me-1 " />
                        {t("type:cardTitle")}
                      </label>
                    }
                    data={suppliers ? suppliers.suppliers : ""}
                    columns={data.columns}
                    fixedHeader
                    fixedHeaderScrollHeight="500px"
                    selectableRows
                    dense
                    onSelectedRowsChange={handleSelectRow}
                    pointerOnHover={true}
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={suppliers ? suppliers.size : 0}
                    paginationDefaultPage={1}
                    onChangePage={handlePageChange}
                    paginationComponentOptions={{
                      rowsPerPageText: t("tableOptions:rowsPerPageText"),
                      rangeSeparatorText: t("tableOptions:rangeSeparatorText"),
                      selectAllRowsItem: true,
                      selectAllRowsItemText: t(
                        "tableOptions:selectAllRowsItemText"
                      ),
                    }}
                    noDataComponent={t("tableOptions:noDataComponent")}
                    progressPending={loading}
                    progressComponent={<LinearIndeterminate />}
                    contextActions={contextActions}
                    persistTableHead
                    onChangeRowsPerPage={handlePerRowsChange}
                    clearSelectedRows={clearSelectedRows}
                    contextMessage={{
                      singular: t("tableOptions:singular"),
                      plural: t("tableOptions:plural"),
                      message: "",
                    }}
                  />
                  <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
                    <ModalHeader toggle={toggle} tag="h4" close={<span></span>}>
                      {t("supplier:titleModal")}
                    </ModalHeader>
                    <ModalBody>
                      <SupplierLimitForm
                        currentSupplier={currentSupplier}
                        onClosing={toggle}
                        onLoad={loadSuppliers}
                      />
                    </ModalBody>
                  </Modal>

                  <Modal isOpen={percentageModalOpen} toggle={togglePercentageModal} backdrop="static">
                    <ModalHeader toggle={togglePercentageModal}>
                      <div className="text-primary">{t("supplier:lblDetailCompliance")}</div>
                      <span className="trext-muted small">{nameSupplier}</span>
                    </ModalHeader>
                    <ModalBody>
                      <h5 className="text-center">
                        <strong>{t("supplier:lblPercentageTotal")}</strong><br />
                        {documentTotal.totalUploaded}{t("supplier:lblOf")}{documentTotal.totalRequired} → {documentTotal.percentage} %
                      </h5>
                      {documentMaterial.totalRequired > 0 && (
                        <>
                          <hr />
                          <h5 className="text-center">
                            <strong>{t("supplier:lblPercentageMaterial")}</strong><br />
                            {documentMaterial.totalUploaded}{t("supplier:lblOf")}{documentMaterial.totalRequired} → {documentMaterial.percentage} %
                          </h5>
                        </>
                      )}
                    </ModalBody>
                  </Modal>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}
export default supplier
